export default __webpack_public_path__ + "static/media/video3.9fdc8935.mp4";